(() => {
  'use strict';
  if (window.BSCodInitialized) return;
  window.BSCodInitialized = true;
  const observers = new WeakMap();
  const editorButtons = new Map();
  const observedAppStyles = new WeakSet();

  function watchAppState() {
    const style = document.getElementById('es-css');
    if (!style || observedAppStyles.has(style)) return;
    observedAppStyles.add(style);
    // EasySell toggles this stylesheet when eligibility enables/disables its form.
    new MutationObserver(() => document.querySelectorAll('[data-bs-product]').forEach(sync))
      .observe(style, {attributes: true, attributeFilter: ['disabled']});
  }

  function sync(root) {
    const button = root.querySelector('[data-bs-cod-button]');
    if (!button) return;
    // The app's own trigger is evidence that COD is enabled for this product.
    // Never offer a dead custom button when the app is off or unavailable.
    if (!root.hasAttribute('data-bs-cod-ready')) {
      if (!root.querySelector('.es-popup-button-product') || typeof window.openTysloForm !== 'function') return;
      root.setAttribute('data-bs-cod-ready', 'true');
    }
    // EasySell may restore inline display after our stylesheet has loaded.
    // Preserve its node and listeners without letting it compete with Studio's CTA.
    root.querySelectorAll('.buy-row > .es-popup-button-product').forEach(trigger => {
      if (trigger.style.getPropertyValue('display') !== 'none' || trigger.style.getPropertyPriority('display') !== 'important') {
        trigger.style.setProperty('display', 'none', 'important');
      }
    });
    watchAppState();
    const appStyle = document.getElementById('es-css');
    const appDisabled = Boolean(appStyle?.disabled || appStyle?.hasAttribute('disabled'));
    button.hidden = appDisabled;
    const form = button.closest('[data-bs-product-form]');
    const variant = form?.querySelector('[name="id"]');
    const quantity = form?.querySelector('[name="quantity"]');
    const unavailable = root.dataset.updating === 'true' || !variant?.value || variant.disabled;
    const disabled = appDisabled || unavailable || !quantity?.validity.valid || Boolean(form?.querySelector('.add-button:disabled'));
    if (button.disabled !== disabled) button.disabled = disabled;
  }

  function mount(root) {
    if (observers.has(root) || !root.querySelector('[data-bs-cod-button]')) return;
    let frame = 0;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; if (root.isConnected) sync(root); });
    };
    const observer = new MutationObserver(schedule);
    observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'data-updating', 'class', 'style']});
    observers.set(root, {observer, schedule, cancel: () => cancelAnimationFrame(frame)});
    schedule();
  }

  document.querySelectorAll('[data-bs-product]').forEach(mount);
  document.addEventListener('input', event => {
    const root = event.target.closest('[data-bs-product]');
    if (root) sync(root);
  });
  // Also protect keyboard activation during a pending/failed variant request.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-bs-cod-button]');
    if (!button) return;
    sync(button.closest('[data-bs-product]'));
    if (button.disabled || button.hidden) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('bs:product:updated', event => sync(event.target));
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-bs-product]').forEach(root => {
      const cached = editorButtons.get(root.id);
      const placeholder = root.querySelector('[data-bs-cod-button]');
      if (cached && placeholder && cached.productId === root.dataset.productId) {
        cached.button.querySelector('span').textContent = placeholder.querySelector('span').textContent;
        placeholder.replaceWith(cached.button);
        root.setAttribute('data-bs-cod-ready', 'true');
        editorButtons.delete(root.id);
      }
      if (cached && cached.productId !== root.dataset.productId) editorButtons.delete(root.id);
      mount(root);
    });
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-bs-product]').forEach(root => {
      const button = root.querySelector('[data-bs-cod-button]');
      if (button && root.hasAttribute('data-bs-cod-ready')) {
        editorButtons.set(root.id, {button, productId: root.dataset.productId});
      }
      const state = observers.get(root);
      state?.observer.disconnect();
      state?.cancel();
      observers.delete(root);
    });
  });
})();
